import * as controlRateActionTypes from 'js/constants/controlRateAction-types';
import axios from 'axios';
import { history } from 'helpers/history';
import Swal from 'sweetalert2';
import getToken from 'helpers/auth';

const getConfig = () => {
  return {
    headers: { Authorization: 'Bearer ' + getToken() },
  };
};

/**
 * Envía un archivo Excel al servidor para actualizar las tarifas de control.
 * @param {Array} files - Un array que contiene el archivo Excel a subir.
 * @returns {function} - Una función asíncrona que realiza la petición al servidor.
 * @throws {Error} Si ocurre un error durante la petición al servidor.
 */
export const postControlRate = (files) => {
  const file = files[0];
  let formData = new FormData();
  formData.append('excel', file);

  return async () => {
    axios
      .post('https://api.metimur.mx/api/tariffs/import', formData, getConfig())
      .then(() => {
        Swal.fire({
          title: 'Control Tarifario Cargado Existosamente',
          icon: 'success',
        }).then(() => {
          history.push('/controlRate');
        });
      })
      .catch((error) => {
        console.log('ERROR API:' + error);
      });
  };
};

/**
 * Obtiene las tarifas de control de un periodo específico.
 * @param {object} control_rate - Un objeto que contiene la información del periodo (división, tipo de tarifa, año y mes).
 * @returns {function} - Una función asíncrona que realiza la petición al servidor y despacha las acciones correspondientes.
 * @throws {Error} Si ocurre un error durante la petición al servidor.
 */
export const showRates = (control_rate) => {
  return async (dispatch) => {
    dispatch(getControlRateStarted());
    axios
      .get(
        `https://api.metimur.mx/api/tariffs/division/${control_rate.division}/rate/${control_rate.rateType}/year/${control_rate.year}/month/${control_rate.month < 9 ? '0' + control_rate.month : control_rate.month}`,
        getConfig()
      )
      .then((response) => {
        dispatch(getControlRateSucces(response.data.data));
      })
      .catch(function (error) {
        console.log('error:' + error);
      });
  };
};

export const getControlRateStarted = () => {
  return {
    type: controlRateActionTypes.GET_CONTROL_RATE_STARTED,
  };
};

export const getControlRateSucces = (control_rate) => {
  return {
    type: controlRateActionTypes.GET_CONTROL_RATE_SUCCESS,
    control_rate,
  };
};

/**
 * Obtiene la última actualización de las tarifas.
 * @returns {function} - Una función asíncrona que realiza la petición al servidor y despacha las acciones correspondientes.
 */
export const showLastUpdateRates = () => {
  return async (dispatch) => {
    dispatch(getLastUpdateRatesStarted());
    axios
      .get(`https://api.metimur.mx/api/rate/lastupdated `, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        dispatch(getLastUpdateRatesSucces(response.data.data));
      })
      .catch(function (error) {
        console.log('error:' + error);
      });
  };
};

export const getLastUpdateRatesStarted = () => {
  return {
    type: controlRateActionTypes.GET_LAST_UPDATE_RATE_STARTED,
  };
};

export const getLastUpdateRatesSucces = (last_update) => {
  return {
    type: controlRateActionTypes.GET_LAST_UPDATE_RATE_SUCCESS,
    last_update,
  };
};

/**
 * Obtiene los reportes totales.
 * @param {object} reportData - Un objeto que contiene los datos del reporte (año, mes, id del medidor, ids de los grupos y tipo de reporte).
 * @returns {function} - Una función asíncrona que realiza la petición al servidor.
 */
export const getTotalReports = (reportData) => {
  return async () => {
    axios
      .post(
        `https://api.metimur.mx/api/report/excel/totals`,
        {
          year: reportData.year,
          month: reportData.month,
          meter_id: reportData.meter,
          group_ids: [reportData.group],
          type: reportData.type,
        },
        getConfig()
      )
      .then(() => {
        console.log('ready');
      })
      .catch(function (error) {
        console.log('Error API: ' + error);
      });
  };
};
